// extracted by mini-css-extract-plugin
export default {"root":"HTab_root__f4+V9","active":"HTab_active__jxbEk","drag-handle":"HTab_drag-handle__pDVAn","hide":"HTab_hide__k5nJC","text":"HTab_text__xZdAL"};